import { useCallback, useEffect, useState } from "react"

export function useMediaQuery(query: string): boolean {
	const getMatches = useCallback((q: string) => window.matchMedia(q).matches, [])
	const [isActive, setIsActive] = useState<boolean>(() => getMatches(query))

	const handleChange = useCallback(() => {
		setIsActive(getMatches(query))
	}, [query, getMatches])

	useEffect(() => {
		const matchMedia = window.matchMedia(query)

		matchMedia.addEventListener("change", handleChange)

		return () => matchMedia.removeEventListener("change", handleChange)
	}, [query, handleChange])

	return isActive
}
